module.exports = __webpack_public_path__ + "header_bg.c3d11be8990861802a41.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/header_bg.jpg
// module id = ../../../../../src/assets/images/header_bg.jpg
// module chunks = styles